import * as React from 'react';
const SvgCheckThin = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 21, height: 16, fill: "none" }, props),
    React.createElement("path", { stroke: "#000", d: "M1 8.637 5.52 15 20 1" })));
export default SvgCheckThin;
